import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AuthService } from '@/services/auth.service';
import { ButtonComponent } from '@/shared/components';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, ButtonComponent],
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  loginData = {
    email: '',
    senha: '',
    lembrar: false
  };

  showPassword = false;
  isLoading = false;
  errorMessage = '';
  returnUrl: string = '/portal';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit() {
     // Get return URL from route parameters or default to '/portal'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/portal';
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
    this.errorMessage = '';
    this.isLoading = true;

    // Login attempt (with or without code2FA)
    this.authService.login({
      email: this.loginData.email,
      password: this.loginData.senha
    }).subscribe({
      next: (response) => {
        this.isLoading = false;
        
        if (response.requires2FA) {
          // Admin requires 2FA - navigate to verify-code screen
          this.router.navigate(['/verificar-codigo'], {
            state: {
              email: this.loginData.email,
              password: this.loginData.senha,
              returnUrl: this.returnUrl,
              mode: 'login2FA'
            }
          });
        } else if (response.token) {
          // Login successful - redirect
          const user = this.authService.getCurrentUser();
          if (user) {
            const redirectPath = this.returnUrl !== '/portal'
              ? this.returnUrl
              : this.authService.getRedirectPath(user.role);
            this.router.navigate([redirectPath]);
          }
        } else {
          this.errorMessage = 'Erro ao fazer login';
        }
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Login error:', error);
        this.errorMessage = error?.error?.message || 'E-mail ou senha inválidos';
      }
    });
  }
}
